import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagosLineaComponent } from './pagos-linea/pagos-linea.component';

const routes: Routes = [
    {
      path: ':country',
      component: PagosLineaComponent
    },
    {
      path: ':country/:type/:cc',
      component: PagosLineaComponent
    },
    {
      path: ':country/:resultado',
      component: PagosLineaComponent
    },
  

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
